:host {
  @apply block w-fit;
}

a {
  background: linear-gradient(to right, #D7004B 50%, #EDEDEC 50%);
  transition: all .4s cubic-bezier(0.3, 0, 0.5, 0.9);
  &.active {
    @apply animate-fillPillLeftRight;
    background-position: 0 100%;
  }
  &:not(.active) {
    background-position: -95% 100%;
    background-size: 210% 100%;
  }
}
